
export default class TextSprite extends THREE.Sprite {
  constructor (text = '', color = '#00939D', textHeight = 10, attenuation = false) {
    super(new THREE.SpriteMaterial({ map: new THREE.Texture(), sizeAttenuation: attenuation, depthTest: false }));

    this._text = text;
    this._textHeight = textHeight;
    this._color = color;
    this.baseScale = new THREE.Vector3();

    this._fontFace = 'sans-serif';
    this._fontSize = 100; // defines text resolution
    this._fontWeight = 'bold';

    this._canvas = document.createElement('canvas');
    this._texture = this.material.map;
    this._texture.minFilter = THREE.LinearFilter;

    this._genCanvas();
  }

  get text () { return this._text; }
  set text (text) {
    this._text = text;
    this._genCanvas();
  }
  get textHeight () { return this._textHeight; }
  set textHeight (textHeight) {
    this._textHeight = textHeight;
    this._genCanvas();
  }
  get color () { return this._color; }
  set color (color) {
    this._color = color;
    this._genCanvas();
  }
  get fontFace () { return this._fontFace; }
  set fontFace (fontFace) {
    this._fontFace = fontFace;
    this._genCanvas();
  }
  get fontSize () { return this._fontSize; }
  set fontSize (fontSize) {
    this._fontSize = fontSize;
    this._genCanvas();
  }
  get fontWeight () { return this._fontWeight; }
  set fontWeight (fontWeight) {
    this._fontWeight = fontWeight;
    this._genCanvas();
  }

  _genCanvas () {
    const canvas = this._canvas;
    const ctx = canvas.getContext('2d');

    const font = `${this.fontWeight} ${this.fontSize}px ${this.fontFace}`;

    ctx.font = font;
    const textWidth = ctx.measureText(this.text).width;
    canvas.width = textWidth;
    canvas.height = this.fontSize;

    ctx.font = font;
    ctx.fillStyle = this.color;
    ctx.textBaseline = 'bottom';
    ctx.fillText(this.text, 0, canvas.height);

    // Inject canvas into sprite
    this._texture.image = canvas;
    this._texture.needsUpdate = true;

    this.baseScale.set(this.textHeight * canvas.width / canvas.height, this.textHeight);
    this.scale.copy(this.baseScale);
  }

  resize (scale) {
    this.scale.copy(scale.clone().multiply(this.baseScale));
  }

  clone () {
    return new TextSprite(this.text, this.textHeight, this.color).copy(this);
  }

  copy (source) {
    THREE.Sprite.prototype.copy.call(this, source);

    this.color = source.color;
    this.fontFace = source.fontFace;
    this.fontSize = source.fontSize;
    this.fontWeight = source.fontWeight;

    return this;
  }

  dispose () {
    this._texture.dispose();
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/TextSprite.js